import React, { useMemo, useState } from 'react';
import { Alert, Button, Card, Form, Input, Typography, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset } from '../services/api';

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await confirmPasswordReset(token, values.password);
      message.success('密码已重置，请重新登录');
      navigate('/login');
    } catch (error) {
      message.error(error.response?.data?.message || error.message || '重置失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card title="重置密码" style={{ width: '100%', maxWidth: 420 }}>
        {!token ? (
          <Alert type="error" message="链接无效，缺少 token" showIcon />
        ) : (
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="新密码"
              name="password"
              rules={[
                { required: true, message: '请输入新密码' },
                { min: 6, message: '密码至少 6 位' },
              ]}
            >
              <Input.Password placeholder="请输入新密码" />
            </Form.Item>
            <Form.Item
              label="确认密码"
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                { required: true, message: '请再次输入新密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="请再次输入新密码" />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={submitting} block>
              提交
            </Button>
          </Form>
        )}
        <Typography.Paragraph style={{ marginTop: 16, marginBottom: 0, color: '#666' }}>
          邮件链接默认 1 小时内有效。
        </Typography.Paragraph>
      </Card>
    </div>
  );
};

export default ResetPassword;
